export function getServiceIdentifierAttribute(valueDecisions, serviceTemplate) {
  return (valueDecisions || []).find(function (serviceAttribute) {
    return serviceAttribute.ServiceIdentifierFlag && (serviceTemplate === null || serviceTemplate === void 0 ? void 0 : serviceTemplate.attributes[serviceAttribute.ServiceAttributeId]);
  }) || {};
}